import { Product } from 'types';

export const someBlocksSoldOut = (blocks: Product[]): boolean => {
  const allBlockDates = blocks.flatMap((block) => block.allBlockDates);
  return allBlockDates.some((blockDate) => !blockDate?.isInPast && blockDate?.spotsLeft === 0);
};
